export function isPWA(): boolean {
  return window.matchMedia("(display-mode: standalone)").matches
}
